import { formatValue } from '@forgd/formatter'

export function formatPerformanceComposite(value: number | null) {
  if (value === null) {
    return 'N/A'
  }

  if (value < 5) {
    return '<5.00'
  }

  return formatValue(value, 'number:2')
}

export const performanceDefinitionMap = {
  grade: {
    term: 'Grade',
    tooltip: 'Letter rating based on overall leaderboard performance.',
    description: 'A simplified letter rating that reflects a market maker\'s overall standing on the leaderboard. Grades are designed to make performance easier to interpret without relying solely on individual numerical scores.',
  },
  composite: {
    term: 'Composite Score',
    tooltip: 'Weighted score used to rank market makers.',
    description: 'The weighted overall score used to rank market makers across the leaderboard. It reflects performance across trading KPIs, trust, coverage and capabilities, uptime, and integration level.',
  },
  tradingKpis: {
    term: 'Trading KPIs',
    tooltip: 'Measures execution quality across depth, volume, spreads, and KPI adherence.',
    description: 'Measures historical execution quality across 500+ tracked engagements. This includes liquidity depth, trading volume, spread performance, and adherence to agreed-upon trading obligations.',
  },
  trust: {
    term: 'Trust',
    tooltip: 'Reflects confidence based on tracked engagements and trading abnormalities.',
    description: 'Reflects Forgd\'s confidence in a market maker\'s observed performance. This is based on the number of tracked engagements and whether Forgd has identified potential trading abnormalities.',
  },
  coverageCapabilities: {
    term: 'Coverage & Capabilities',
    tooltip: 'Evaluates exchange coverage, ecosystem reach, and broader service offerings.',
    description: 'Evaluates the breadth of a market maker\'s exchange coverage, ecosystem reach, and broader service offering. This includes centralized and decentralized exchange connectivity, as well as services beyond standard liquidity provision.',
  },
  uptime: {
    term: 'Uptime',
    tooltip: 'Measures consistency in meeting contractual depth, spread, and availability requirements.',
    description: 'Measures a market maker\'s consistency in meeting contractual obligations across tracked engagements. This typically includes maintaining required depth, spreads, and availability across supported venues.',
  },
  integrationLevel: {
    term: 'Integration Level',
    tooltip: 'Reflects connectivity with Forgd\'s data systems and RFQ participation.',
    description: 'Reflects the degree of connectivity between the market maker and Forgd\'s data systems. Higher integration levels provide greater visibility into tracked engagements, RFQ participation, and ongoing performance.',
  },
}

export const performanceDefinitions = [
  performanceDefinitionMap.grade,
  performanceDefinitionMap.composite,
  performanceDefinitionMap.tradingKpis,
  performanceDefinitionMap.trust,
  performanceDefinitionMap.coverageCapabilities,
  performanceDefinitionMap.uptime,
  performanceDefinitionMap.integrationLevel,
]
